<template>
  <section class="NotFoundContainer">
    <ParticalsComponent />
    <article>
      <img src="@/assets/404.png" />
    </article>
    <WaveFooter />
  </section>
</template>

<script>
import WaveFooter from "@/components/WavFooter";
import ParticalsComponent from "@/components/ParticalsComponent";
export default {
  name: "NotFound",
  components: {
    ParticalsComponent,
    WaveFooter,
  },
};
</script>
